import React__default from 'react';
import { Box, TableContainer, Table, TableHead, TableRow, TableBody, TablePagination, Paper } from '@mui/material';
import clsx from 'clsx';

var KTable = function KTable(_a) {
    var className = _a.className, columnsComponent = _a.columnsComponent, children = _a.children, id = _a.id, _b = _a.testId, testId = _b === void 0 ? "KTable" : _b, pageSize = _a.pageSize, pageNumber = _a.pageNumber, loading = _a.loading, loadingComponent = _a.loadingComponent, onPageSizeChange = _a.onPageSizeChange, onPageNumberChange = _a.onPageNumberChange, totalCount = _a.totalCount, noResultComponent = _a.noResultComponent, tableContainerComponent = _a.tableContainerComponent, _c = _a.rowsPerPageOptions, rowsPerPageOptions = _c === void 0 ? [5, 10, 25] : _c, sx = _a.sx;
    var handleChangePage = function (_, page) {
        onPageNumberChange && onPageNumberChange(page + 1);
    };
    var handleChangeRowsPerPage = function (event) {
        onPageSizeChange && onPageSizeChange(parseInt(event.target.value, 10));
        onPageNumberChange && onPageNumberChange(1);
    };
    var TableContainerComponent = (tableContainerComponent && tableContainerComponent) || Paper;
    return (React__default.createElement(Box, { sx: sx },
        React__default.createElement(TableContainer, { component: TableContainerComponent },
            React__default.createElement(Table, { id: id, "data-testid": testId, className: clsx("KTable", className) },
                React__default.createElement(TableHead, null,
                    React__default.createElement(TableRow, null, columnsComponent)),
                React__default.createElement(TableBody, null,
                    React__default.createElement(React__default.Fragment, null,
                        !loading && totalCount === 0 && noResultComponent,
                        loading && loadingComponent,
                        children)))),
        totalCount && pageSize && pageNumber ? (React__default.createElement(TablePagination, { rowsPerPageOptions: rowsPerPageOptions, component: "div", count: totalCount, rowsPerPage: pageSize, page: pageNumber - 1, onPageChange: handleChangePage, onRowsPerPageChange: handleChangeRowsPerPage })) : null));
};

export { KTable as default };
//# sourceMappingURL=index.js.map
